/** MarketingAttributionRoute — skin-aware switcher for /marketing-attribution and /marketing. */
import { useUISkin } from "@/data/UISkinContext";
import MarketingAttribution from "./MarketingAttribution";
import MarketingAttributionCockpit from "./MarketingAttributionCockpit";
export default function MarketingAttributionRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <MarketingAttributionCockpit />;
  return <MarketingAttribution />;
}
